import { Dialog as DialogPrimitive } from '@base-ui/react/dialog';
import { Trans } from '@lingui/react/macro';
import type { ReactNode } from 'react';

import XIcon from '@/assets/svg/bx-x.svg?react';
import { Button } from '@/components/buttons';
import { cn } from '@/lib/utils';

import DialogOverlay from './DialogOverlay';
import DialogPortal from './DialogPortal';

export type DialogContentProps = DialogPrimitive.Popup.Props & {
  showCloseButton?: boolean;
  children?: ReactNode;
};

const DialogContent = ({
  className,
  children,
  showCloseButton = true,
  ...props
}: DialogContentProps) => {
  return (
    <DialogPortal>
      <DialogOverlay />
      <DialogPrimitive.Popup
        data-slot="dialog-content"
        className={cn(
          'fixed top-1/2 left-1/2 z-1100',
          'grid w-full gap-6 rounded-2xl bg-white px-6 pt-14 pb-10 text-base',
          'max-w-[calc(100%-2rem)] sm:max-w-lg md:max-w-2xl',
          '-translate-1/2',
          'ring-1 ring-gray-900/10 outline-none',

          'duration-100',
          'data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95',
          'data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95',
          className,
        )}
        {...props}
      >
        {children}
        {showCloseButton && (
          <DialogPrimitive.Close
            data-slot="dialog-close"
            render={
              <Button variant="ghost" className="absolute top-3 right-3" size="icon">
                <XIcon />
                <span className="sr-only">
                  <Trans>Close</Trans>
                </span>
              </Button>
            }
          />
        )}
      </DialogPrimitive.Popup>
    </DialogPortal>
  );
};

export default DialogContent;
